import { Card } from '@1trading/react';
import { TriangleAlert } from 'lucide-react';

interface NotFoundPanelProps {
  title: string;
  message: string;
}

/** Full-page state for a detail route whose record does not exist */
export const NotFoundPanel = ({ title, message }: NotFoundPanelProps) => (
  <Card className="flex w-full max-w-xl flex-col items-start gap-3 p-6">
    <div className="flex items-center gap-2 text-red-500">
      <TriangleAlert className="size-5" />
      <h2 className="text-lg font-semibold">{title}</h2>
    </div>
    <p className="text-sm text-muted-foreground">{message}</p>
  </Card>
);
NotFoundPanel.displayName = 'NotFoundPanel';
